import {LoadingSvg} from '@/icons';
import styles from './index.module.scss';

export function Loading() {
    return <div className={styles.loadingStatus}><LoadingSvg />加载中</div>;
}

export function Loaded() {
    return <div className={styles.loadedStatus}>- 仅展示近6个月的数据哦 -</div>;
}

export function NoResult() {
    return <div className={styles.nullStatus}>未找到相关结果</div>;
}

interface IError {
    onReload: () => void;
}
export function LoadError(props: IError) {
    const {onReload} = props;
    return <div className={styles.errorStatus}>没加载成功呢，<span onClick={onReload}>请再试试</span></div>;
}

export function CloseTips() {
    return <div className={styles.loadedStatus}>管理员已关闭浏览记录</div>;
}
